(function() {

  'use strict';

    $('#filtraCategoria').on('change', function(){
  	document.location = $(this).val();
  	})

}());
